import React from 'react';
import { SidebarThemeContext } from '../../context';
import { usePlanStatus } from '../../hooks/usePlanStatusHook';
import { DiamondIcon } from '../Icons';

// UpgradeBadge used to show the user when they need to upgrade to a paid plan
// when allowStandard show the badge on trial plans
// else show badge on trial/basic plan
export const UpgradeBadge = ({ color = 'white', allowStandard = false }) => {
  const planStatus = usePlanStatus();
  const { itemTextColor } = React.useContext(SidebarThemeContext);
  const showBadge = allowStandard
    ? planStatus.isTrialing
    : planStatus.requireProUpgrade;
  return showBadge ? (
    <DiamondIcon style={{ fontSize: 16, color: itemTextColor || color }} />
  ) : null;
};
